<template>
  <div style="background-color: #0a0f28">
    <div style="width: 100%; display: flex; align-items: center; justify-content: center">
      <text style="color: #02b4ff; font-size: 28px; margin-top: 24px">无人车已送达包裹量统计看板</text>
    </div>
    <search-bar ref="searchRef" @search="doSearch" :need-time="false"/>
    <div class="card-container">
      <!-- 1. 完全不传参数 (使用全部默认值: 默认图标, 默认标题, 默认颜色, 默认显示--) -->
      <DashboardCard title="今日送达包裹量" :value="transferData(cardData.todayDeliverNum)" borderColor="#00d8ff" />

      <!-- 2. 还原图1：已投放无人车总量 (蓝色) -->
      <DashboardCard title="昨日送达包裹量" :value="transferData(cardData.yesterdayDeliverNum)" borderColor="#00d8ff">
        <!-- 这里省略 icon 插槽，因为组件自带的默认图标就是车 -->
      </DashboardCard>

      <!-- 3. 还原图3：投递中数量 (绿色) -->
      <DashboardCard title="近7日送达包裹量" :value="transferData(cardData.last7dDeliverNum)" borderColor="#00e676">
        <template #icon>
          <!-- 传入自定义的 SVG 图标 (纸飞机) -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        </template>
      </DashboardCard>

      <!-- 4. 还原图4：充电/待命数量 (黄色) -->
      <DashboardCard title="近30日送达包裹量" :value="transferData(cardData.last30dDeliverNum)" borderColor="#ffc107">
        <template #icon>
          <!-- 传入自定义的电池图标 -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <rect x="2" y="7" width="16" height="10" rx="2" ry="2"></rect>
            <line x1="22" y1="11" x2="22" y2="13"></line>
          </svg>
        </template>
      </DashboardCard>

      <!-- 5. 还原图5：离线数量 (红色) -->
      <DashboardCard title="累计送达包裹量" :value="transferData(cardData.totalDeliverNum)" borderColor="#ff4d4f">
        <template #icon>
          <!-- 传入自定义的开关机图标 -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
            <line x1="12" y1="2" x2="12" y2="12"></line>
          </svg>
        </template>
      </DashboardCard>
      <DashboardCard title="近7日日均送达量" :value="transferData(cardData.avg7dDailyDeliverNum)" borderColor="#00d8ff">
        <!-- 这里省略 icon 插槽，因为组件自带的默认图标就是车 -->
      </DashboardCard>
      <DashboardCard title="近30日日均送达量" :value="transferData(cardData.avg30dDailyDeliverNum)" borderColor="#00d8ff">
        <!-- 这里省略 icon 插槽，因为组件自带的默认图标就是车 -->
      </DashboardCard>
      <DashboardCard title="总日均送达量" :value="transferData(cardData.totalAvgDailyDeliverNum)" borderColor="#00d8ff">
        <!-- 这里省略 icon 插槽，因为组件自带的默认图标就是车 -->
      </DashboardCard>
    </div>
    <div style="padding: 0 24px 24px 24px">
      <PackageLineChart ref="packageLineRef" :cycle-type="cycleType" @change-cycle-type="changeCycleType"/>
    </div>


  </div>
</template>

<script setup>
import DashboardCard from '@/components/tdl/data/package/DashboardCard.vue'
import SearchBar from '@/components/tdl/data/package/SearchBar.vue'
import PackageLineChart from '@/components/tdl/data/package/PackageLineChart.vue'
import { useHostAppInstance } from '@zto/zpage'
import { onMounted, ref } from 'vue'
const app = useHostAppInstance()
const cardData = ref({})
const packageLineRef = ref()
const searchRef = ref()

const cycleType = ref('DAY')

const changeCycleType = (type) => {
  console.log('====changeCycleType:', type)
  cycleType.value = type
  const params = searchRef.value.getSearchParams()
  const lineParams = {...params, cycleType: type}
  packageLineRef.value.queryLineData(lineParams)

}
const transferData = (num) => {
 if (typeof num === 'number') {
   return num
 }
  return '--'
}

const doSearch =  (params) => {
  console.log('===doSearch CTdlPackageData:', JSON.stringify(params))
  queryCardData(params)
  cycleType.value = 'DAY'
  const lineParams = {...params, cycleType: 'DAY'}
  packageLineRef.value.queryLineData(lineParams)
}
const queryCardData = async (params) => {
  try {
    const resp = await app.request({
      api: '/sys/admin/statistics/page-statistics/package-delivery-board',
      params: params
    })
    // console.log('====doSearch resp:', JSON.stringify(resp))
    if (resp) {
      cardData.value = resp
    }
  } catch (e) {

  }
}
onMounted(() => {
  searchRef.value.handleShortcut(7)
  const params = searchRef.value.getSearchParams()
  packageLineRef.value.initChart()
  doSearch(params)
});
</script>

<style scoped>
.card-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  background-color: #0a0f28; /* 页面深色底色 */
  padding: 20px;
}
</style>
